export default {
  general: {
    showFavourites: false,
  },

  filter: {
    enabled: false,
  },
};
